import * as React from "react";
import { useState } from "react";
import {
  Box,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Chip,
  Grid,
  Typography,
  CircularProgress,
  Checkbox,
  FormControlLabel,
  FormControl,
  FormHelperText,
  TextField
} from "@mui/material";
import { OrderStatusEnumIcons, OrderHistoryTypeEnumIcons, OrderHistoryTypeEnum } from "src/common/enum";
import { useDataProvider, useRefresh } from "react-admin";
import { SelectField } from "src/components/input";
import Transformer from "src/common/Transformer";
import { useForm } from "react-hook-form";
import ApiResources from "src/providers/ApiResources";
import { formatDateTime } from "src/common/UtilFunctions";

export const HistoryTable = (props) => {
    const { record, ...rest } = props;

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { register, control, reset, handleSubmit, getValues, setValue, formState: { errors }} = useForm();
    const dataProvider = useDataProvider();
    const refresh = useRefresh();
  
    const transform = (data) => {
        Transformer(data, {
            update: {
                order: record.id,
                status: record.status             
            },
        });
        return data;
    };

    const create = (data) => {
        try {
            let formData = {...data, order: record.id};

            setLoading(true);
            setError(null);
            dataProvider
            .create(ApiResources.createOrderHistory(false), {
                data: formData,
            })
            .then((res) => {
                setLoading(false);
                refresh();
                reset();
            })
            .catch((error) => {
                setError(error.message);
                setLoading(false);
            });
        } catch (e) {
            console.log(e);
        }
    }

    const style = {
        marginTop: "18px",
        padding: "20px",
        border: "1px solid #ebebeb", 
        borderRadius: "8px", 
        boxShadow: "0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)"
    };

    return (
        <>
        <TableContainer sx={{border: "1px solid #ebebeb", borderRadius: "8px", boxShadow: "0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)"}}>
            <Table size="small">
                <TableHead>
                <TableRow>
                    <TableCell/>
                    <TableCell>
                    Message
                    </TableCell>
                    <TableCell>
                    Status
                    </TableCell>
                    <TableCell>
                    Created At
                    </TableCell>
                    <TableCell/>
                </TableRow>
                </TableHead>

                <TableBody>
                { record?.histories?.map((historyItem, historyItemIndex) => {
                    let statusEnum = OrderStatusEnumIcons.find((status) => status.id === historyItem.status);
                    let typeEnum = OrderHistoryTypeEnumIcons.find((type) => type.id === historyItem.type);

                    return (
                        <TableRow key={`row_${historyItemIndex}`} >
                            <TableCell sx={{width: "0px",whiteSpace: "nowrap"}}>
                                {typeEnum && typeEnum.icon}
                            </TableCell>
                            <TableCell  sx={{width: "100%"}}>
                                {historyItem.message}
                            </TableCell>
                            <TableCell sx={{width: "0px",whiteSpace: "nowrap"}}>
                                {statusEnum &&
                                <Chip sx={{fontSize: "12px", padding: "4px 6px", height: "auto"}} label={statusEnum.name} color={statusEnum.color as any} icon={statusEnum.icon}/>
                                }
                            </TableCell>
                            <TableCell sx={{width: "0px",whiteSpace: "nowrap"}}>
                                {formatDateTime(historyItem.created_at)}
                            </TableCell>
                            <TableCell>
                            </TableCell>
                        </TableRow>
                    )   
                })}
                </TableBody>
            </Table>
        </TableContainer>
        <Box sx={style}>
        <form onSubmit={handleSubmit(create)} noValidate>
            <Grid container item sm={12} rowSpacing={1} columnSpacing={2}>
                <Grid item sm={12} md={12}>
                    <TextField
                        label="State"
                        variant="outlined"
                        size="small"
                        value={OrderStatusEnumIcons.find((status) => status.id === record.status).name}
                        disabled
                    />
                </Grid>
                <Grid item sm={12} md={12}>
                    <SelectField
                        label="Type"
                        size="small"
                        value={getValues("type") || ""}
                        error={!!errors.type}
                        helperText={(errors.type as any)?.message}
                        required
                        {...register("type", {
                            required: "Field is required"
                        })}
                        onChange={(e) => {
                            setValue('type', e.target.value, { shouldValidate: true });
                        }}
                        choices={OrderHistoryTypeEnum}
                    />
                </Grid>  
                <Grid item sm={12} md={12}>
                    <FormControl
                        error={!!errors.notify}
                        {...register("notify")}
                    >
                        <FormControlLabel control={
                            <Checkbox
                                value={getValues("notify") || false}
                                onChange={(e) => {
                                    setValue('notify', e.target.checked, { shouldValidate: true });
                                }}  
                            />
                        } label="Notify Customer by Email" />
                        {!!errors.type &&
                        <FormHelperText>{(errors.type as any)?.message}</FormHelperText>
                        }
                    </FormControl>
                </Grid>

                <Grid item sm={12} md={12}>
                    <TextField
                        label="Message"
                        variant="outlined"
                        size="small"
                        multiline
                        rows={2}
                        error={!!errors.message}
                        helperText={(errors.message as any)?.message}
                        required
                        {...register("message", {
                            required: "Field is required"
                        })}
                    />
                </Grid>

                { error &&
                <Grid item sm={12} md={12} sx={{marginBottom: "18px", display: "flex"}}>
                    <Typography variant="subtitle2" color="error">{error}</Typography>
                </Grid>                     
                }

                <Grid item sm={12} md={12} sx={{display: "flex",marginTop: "18px", gap: "0.5em", justifyContent: "end"}}>
                    <Button variant="contained" type="submit" disabled={loading}>
                        {loading && <CircularProgress size={18} thickness={2} sx={{ fontSize: "18px", color: "#ffffff",marginRight: "8px"}}/>}
                        Add Message
                    </Button>
                </Grid> 
            </Grid> 
        </form>
        </Box>
        </>
    );
}
